// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
import { SpinnerMethods } from '@/mixins/helpers/SpinnerMethods'
import { GetFutureRentTerms } from '@/events/rent/GetFutureRentTerms'
import { GetCurrentRentTerms } from '@/events/rent/GetCurrentRentTerms'

// Import firebase
import { propertiesModel, residentsModel, rentsModel } from '@/firebase/firebase-config'
import moment from 'moment';

export const UpdateRentTerm = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService,
        SpinnerMethods,
        GetFutureRentTerms,
        GetCurrentRentTerms

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        updated_rent_error: false,
        updated_rent_saved: false,
        updated_rent_complete: false,
        rent_starting_at: null,
        rent_ending_at: null,
        currentTotalBalance: 0,
        currentOutstandingBalance: 0,
        totalMonthlyRent: 0,
        totalFutureBalance: 0

    }),

    /*
    **  Watch em'
    */

    watch: {

        updated_rent_saved: {

            immediate: true, // Load on created
            handler(updated_rent_saved) {

                /*
                **  Update the lease
                **  @method: @here
                */
                
                if (updated_rent_saved && !this.updated_rent_error && this.edited_rent.term.value == 'current') this.updateLeaseForUpdatedRent();

                /*
                **  Update the resident
                **  @method: @here
                */

                if (updated_rent_saved && !this.updated_rent_error && this.edited_rent.term.value == 'current') this.updateResidentForUpdatedRent();

                /*
                **  Update the property resident
                **  @method: @here
                */

                if (updated_rent_saved && !this.updated_rent_error && this.edited_rent.term.value == 'current') this.updatePropertyResidentForUpdatedRent();

                /*
                **  Update the unit
                **  @method: @here
                */

                if (updated_rent_saved && !this.updated_rent_error && this.edited_rent.term.value == 'current') this.updateUnitForUpdatedRent();

                /*
                **  Update the property
                **  @method: @here
                */

                if (updated_rent_saved && !this.updated_rent_error) this.getFutureRentTermsHandler(this.rent.relationships.property);
                if (updated_rent_saved && !this.updated_rent_error) this.getCurrentRentTermsHandler(this.rent.relationships.property);

                /*
                **  Set the completed prop
                **  @prop: @here
                */
                
                if (this.processing) this.updated_rent_complete = true;

            }

        },

        updated_rent_error: {

            immediate: true, // Load on created
            handler(updated_rent_error) {

                /*
                **  Handle the error
                **  @method: @here
                */

                if (updated_rent_error) this.handleUpdatedRentError();

            }

        },

        updated_rent_complete: {

            immediate: true, // Load on created
            handler(updated_rent_complete) {

                /*
                **  Complete the transaction
                **  @method: @here
                */
                
                if (updated_rent_complete) this.completeTheUpdatedRentTransaction();

            }

        },

        current_rent_terms: {

            immediate: true, // Load on created
            handler(current_rent_terms) {

                /*
                **  Complete the transaction
                **  @method: @here
                */

                if (current_rent_terms.length > 0) this.updatePropertyCurrentMetricsForUpdatedRent();

            }

        },

        future_rent_terms: {

            immediate: true, // Load on created
            handler(future_rent_terms) {

                /*
                **  Complete the transaction
                **  @method: @here
                */
                
                if (future_rent_terms.length > 0) this.updatePropertyFutureMetricsForUpdatedRent();

            }

        }

    },

    /*
	**  Methods
    */
    
    methods: {

        handleUpdatedRentError: function() {

            try {

                /*
                **  Set the processing prop
                **  @prop: @here
                */

                this.processing = false;

                /*
                **  Reset the props
                **  @props: @here
                */

                this.updated_rent_saved = false;
                this.updated_rent_error = false;
                this.updated_rent_complete = false;
    
                /*
                **  Hide the spinner
                **  @method: Mixins/Helpers/SpinnerMethods
                */

                this.hideSpinner();

                /*
                **  Throw error message
                **  @service: SweetAlert2
                */

                this.$swal('Uh Oh!', 'We ran into some problems while trying to update your new rent term.', 'error');

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Handle an Error for a Rent Term Update.',
                    errorType: 'Application',
                    section: 'Update Rent',
                    uid: 'NoxjyDxGf0FzNJvwYXTL',
                    error: e
                });

            }

        },

        updateRentTermHandler: function() {

            /*
            **  Set the processing prop
            **  @prop: @here
            */

            this.processing = true;

            /*
            **  Show the spinner
            **  @method: Mixins/Helpers/SpinnerMethods
            */

			this.showSpinner();

            /*
            **  Convert the dates
            **  @method: @here
            */

            this.convertUpdatedRentDates()
            .then(() => {

                /*
                **  Convert amounts to cents
                **  @method: @here
                */

				if (!this.updated_rent_error) this.convertUpdatedRentAmounts();

            })
            .then(() => {

                /*
                **  Calculate total balance
                **  @method: @here
                */
                
				if (!this.updated_rent_error) this.calculateUpdatedRentTotalBalance();

            })
            .then(() => {

                /*
                **  Update the rent term
                **  @method: @here
                */

				if (!this.updated_rent_error) this.updateRentTermDocument();

            });

        },

        convertUpdatedRentDates: async function() {

            try {

                /*
                **  Convert the dates
                **  @service: Repositories/Rent/RentRepository
                */

                this.rent_starting_at = moment(this.edited_rent.starting_at.value).unix();
                this.rent_ending_at = moment(this.edited_rent.ending_at.value).unix();

            } catch (e) {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.updated_rent_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Convert Dates When Creating a Rent Term.',
                    errorType: 'Application',
                    section: 'Lease Overview',
                    uid: 'X9NWKL9WkXIN0bD1VUCh',
                    error: e
                });

            }

        },

        convertUpdatedRentAmounts: function() {

            try {

                /*
                **  Convert the amounts
                **  @props: Components/Property/Lease/Rent/EditRentMenu
                */

                this.edited_rent.amount.value = Number(this.edited_rent.amount.value) * 100;
                this.edited_rent.amount.value = Number(this.edited_rent.amount.value.toFixed(0));
                this.edited_rent.late_fee.value = Number(this.edited_rent.late_fee.value * 100);
                this.edited_rent.first_month_charge_amount.value = Number(this.edited_rent.first_month_charge_amount.value) * 100;
                
                /*
                **  If transaction fees are added
                **  @props: Repositories/Rent/RentRepository
                */

                if (this.edited_rent.fee_amount.value > 0) {

                    // Set the fee amount
                    this.edited_rent.fee_amount.value = Number(this.edited_rent.fee_amount.value) * 100;

                }

            } catch (e) {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.updated_rent_error = true;

                /*  
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Convert the New Rent Amounts When Editing a Rent Term.',
                    errorType: 'Application',
                    section: 'Edit Rent',
                    uid: 's6EyTwFzfQ6sA160M2xH',
                    error: e
                });

            }

        },

        calculateUpdatedRentTotalBalance: function() {

            try {

                /*
                **  Set the total_balance
                **  @props: Components/Property/Lease/Rent/EditRentMenu
                */

                if (this.edited_rent.prorated) {

                    /*
                    **  Set the prorated balance
                    **  @props: Components/Property/Lease/Rent/EditRentMenu
                    */

                    this.edited_rent.total_balance = (this.edited_rent.total_charges * this.edited_rent.amount.value) + this.edited_rent.first_month_charge_amount.value;
                    this.edited_rent.total_balance = Number(this.edited_rent.total_balance.toFixed(0));
                
                } else {

                    /*
                    **  Set the non-prorated balance
                    **  @props: Components/Property/Lease/Rent/EditRentMenu
                    */

                    this.edited_rent.total_balance = this.edited_rent.amount.value * this.edited_rent.total_charges;
                    this.edited_rent.total_balance = Number(this.edited_rent.total_balance.toFixed(0));

                }

                /*
                **  Add transaction fee
                **  @props: Components/Property/Lease/Rent/EditRentMenu
                */

                if (this.edited_rent.method_type.value == 'resident') {

                    /*
                    **  Add to the balance
                    **  @props: Components/Property/Lease/Rent/EditRentMenu
                    */

                    this.edited_rent.total_balance = this.edited_rent.total_balance + (this.edited_rent.total_charges * this.edited_rent.fee_amount.value);
                    this.edited_rent.total_balance = Number(this.edited_rent.total_balance.toFixed(0));

                }

                /*
                **  Set the outstanding balances
                **  @prop: @here
                */

                this.edited_rent.outstanding_balance = this.edited_rent.total_balance - this.rent.metrics.total_paid_amount;

            } catch (e) {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.updated_rent_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Calculate the New Rent Totals When Editing a Rent Term.',
                    errorType: 'Application',
                    section: 'Edit Rent',
                    uid: 'EF8Z52Yjoyjpb55WEtsH',
                    error: e
                });

            }

        },

        updateRentTermDocument: function() {

            try {

                propertiesModel.doc(this.rent.relationships.property).collection('leases').doc(this.rent.relationships.lease).collection('rents').doc(this.rent.id).update({
                    'meta.updated_at': moment().unix(),
                    'metrics.total_balance': this.edited_rent.total_balance,
                    'metrics.total_charges': this.edited_rent.total_charges,
                    'attributes.term': this.edited_rent.term.value,
                    'attributes.term_dates.starting_at': this.rent_starting_at,
                    'attributes.term_dates.ending_at': this.rent_ending_at,
                    'attributes.amount': this.edited_rent.amount.value,
                    'attributes.policy.cycle': this.edited_rent.cycle.value,
                    'attributes.policy.due_on': this.edited_rent.due_on.value,
                    'attributes.policy.late_by': this.edited_rent.late_by.value,
                    'attributes.due_notification.days_in_advance': this.edited_rent.days_in_advance.value,
                    'attributes.policy.late_fee': this.edited_rent.late_fee.value,
                    'attributes.transaction_fees_policy.set_policy': this.edited_rent.set_policy.value,
                    'attributes.transaction_fees_policy.method_type': this.edited_rent.method_type.value,
                    'attributes.transaction_fees_policy.resident.fee_amount': this.edited_rent.fee_amount.value,
                    'attributes.first_month.prorated': this.edited_rent.prorated,
                    'attributes.first_month.charge_amount': this.edited_rent.first_month_charge_amount.value
                })
                .then(() => {
                    
                    /*
                    **  Set the prop
                    **  @prop: @here
                    */
                    
                    this.updated_rent_saved = true;

                })
                .catch(error => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.updated_rent_error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Unable to Set a New Rent Term in Firestore When Editing a Rent Term.',
                        errorType: 'Application',
                        section: 'Edit Rent',
                        uid: 'NuvCIGs17GYkIGIxjY7O',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.updated_rent_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Update a Rent Term.',
                    errorType: 'Application',
                    section: 'Edit Rent',
                    uid: 'ghyKlxvF8gpWuy8bzfPW',
                    error: e
                });

            }

        },

        completeTheUpdatedRentTransaction: function() {

            try {

                /*
                **  Reset the validation props
                **  @prop: Components/Property/Lease/Rent/EditRentMenu
                */

                this.resetValidationProps();

                /*
                **  Reset the terms props
                **  @prop: @here
                */

                this.future_rent_terms = [];
                this.current_rent_terms = [];
 
                /*
                **  Set the processing prop
                **  @prop: Components/Property/Lease/Rent/AddRentMenu
                */

                this.processing = false;

                /*
                **  Reset the props
                **  @props: @here
                */

                this.updated_rent_saved = false;
                this.updated_rent_error = false;
                this.updated_rent_complete = false;
                this.currentTotalBalance = 0;
                this.currentOutstandingBalance = 0;
                this.totalMonthlyRent = 0;
                this.totalFutureBalance = 0;
 
                /*
                **  Close the menu
                **  @method: Components/Property/Lease/Rent/EditRentMenu
                */

                this.closeEditRentMenu();

                /*
                **  Hide the spinner
                **  @method: Mixins/Helpers/SpinnerMethods
                */

                this.hideSpinner();

                /*
                **  Throw success message
                **  @service: SweetAlert2
                */

                this.$swal('Success!', 'Your rent term has been updated.', 'success');

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Complete the Transaction when Updating a Rent Term.',
                    errorType: 'Application',
                    section: 'Update Rent',
                    uid: 'D97fv3gVjckA4EzRf7XP',
                    error: e
                });

            }

        },

        updateLeaseForUpdatedRent: function() {

            try {

                /*
                **  Set the var
                */

                let firstMonthsRent = Number(this.edited_rent.amount.value);

                /*
                **  Set first months rent
                **  @prop: Repositories/Rent/RentRepository
                */

                if (this.edited_rent.prorated) firstMonthsRent = Number(this.edited_rent.first_month_charge_amount.value);

                /*
                **  Update the lease
                **  @service: Firebase/Firestore
                */

                propertiesModel.doc(this.rent.relationships.property).collection('leases').doc(this.rent.relationships.lease).update({

                    'attributes.details.start_date': this.rent_starting_at,
                    'attributes.details.end_date': this.rent_ending_at,
                    'attributes.rent.amount': Number(this.edited_rent.amount.value),
                    'attributes.rent.beginning_at': this.rent_starting_at,
                    'attributes.rent.cycle': this.edited_rent.cycle.value,
                    'attributes.rent.due_on': this.edited_rent.due_on.value,
                    'attributes.rent.first_months_rent': firstMonthsRent,
                    'attributes.rent.post_days_in_advance': this.edited_rent.days_in_advance.value,
                    'attributes.rent.prorated': this.edited_rent.prorated,
                    'metrics.initial_balance': this.edited_rent.total_balance,
                    'metrics.outstanding_balance': this.edited_rent.outstanding_balance,
                    'metrics.rent.total_charges': this.edited_rent.total_charges,
                    'relationships.active_rent': this.rent.id,
                    'meta.updated_at': moment().unix()

                })
                .catch(error => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.updated_rent_error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Update Lease - Update Lease for Edit Rent in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Edit Rent',
                        uid: 'vo8OAw70gNU15Xw8cgom',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.updated_rent_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Query Firestore When Updating a Lease for an Updated Rent Term.',
                    errorType: 'Application',
                    section: 'Edit Rent ',
                    uid: 'RWIggSavA3qxBMGXkiKC',
                    error: e
                });

            }

        },

        updateResidentForUpdatedRent: function() {

            try {

                residentsModel.doc(this.rent.relationships.resident).update({

                    'attributes.rent.current': this.edited_rent.amount.value,
                    'meta.updated_at': moment().unix()
    
                })
                .catch(error => {
                    
                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.updated_rent_error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Update Resident Current Rent in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Edit Rent',
                        uid: 'p6YFrYlSU2MWABGYut6s',
                        error: error
                    });
    
                });

            } catch (e) {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.updated_rent_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Query Firestore When Updating a Resident for an Updated Rent Term.',
                    errorType: 'Application',
                    section: 'Edit Rent',
                    uid: 'QNVc2AWWqQM5DJUyV27l',
                    error: e
                });

            }

		},

        updatePropertyResidentForUpdatedRent: function() {

            try {

                propertiesModel.doc(this.rent.relationships.property).collection('residents').doc(this.rent.relationships.resident).update({

                    'attributes.rent.current': this.edited_rent.amount.value,
                    'meta.updated_at': moment().unix()
    
                })
                .catch(error => {
    
                    // Send to bugsnag
                    this.reportAuthBugsnagError({
                        title: 'Update Property Resident Current Rent in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Edit Rent',
                        uid: 'WLFwlkyk6TeDreVds3xu',
                        error: error
                    });
    
                });

            } catch (e) {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.updated_rent_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Query Firestore When Updating a Resident When Editing a Rent Term.',
                    errorType: 'Application',
                    section: 'Edit Rent',
                    uid: 'q7ISf47jej6xcG0Ul7XP',
                    error: e
                });

            }

		},

        updateUnitForUpdatedRent: function() {

            try {

                propertiesModel.doc(this.rent.relationships.property).collection('units').doc(this.rent.relationships.unit).update({

                    'attributes.rent.current': this.edited_rent.amount.value,
                    'meta.updated_at': moment().unix()
    
                })
                .catch(error => {
    
                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.updated_rent_error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Update Property Unit Current Rent in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Edit Rent',
                        uid: 'w1E1EvGRIv8VrjLDmNR0',
                        error: error
                    });
    
                });

            } catch (e) {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.updated_rent_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Query Firestore When Updating a Unit When Editing a Rent Term.',
                    errorType: 'Application',
                    section: 'Edit Rent',
                    uid: 'yj0Y0AlaTlWdc9RWxh6e',
                    error: e
                });

            }

		},

        updatePropertyCurrentMetricsForUpdatedRent: function() {

            try {

                /*
                **  Loop through and total up the balance for the property
                */

                if (this.current_rent_terms.length > 0) {

                    this.current_rent_terms.forEach(rent => {

                        /*
                        **  Set the inidividual rent outstanding balance
                        */

                        let rentOutstandingBalance = rent.metrics.total_balance - rent.metrics.total_paid_amount;

                        /*
                        **  Update the vars
                        */

                        this.currentTotalBalance = this.currentTotalBalance + rent.metrics.total_balance;
                        this.currentOutstandingBalance = this.currentOutstandingBalance + rentOutstandingBalance;
                        this.totalMonthlyRent = this.totalMonthlyRent + rent.attributes.amount;

                    });

                } else {

                    /*
                    **  Update the vars
                    */

                    this.currentTotalBalance = 0;
                    this.currentOutstandingBalance = 0;
                    this.totalMonthlyRent = 0;

                }

                /*
                **  Update the document
                **  @service: @Firebase/Firestore
                */

                propertiesModel.doc(this.property.id).update({

                    'metrics.units.total_monthly_rent': this.totalMonthlyRent,
                    'metrics.leases.active.outstanding_balance': this.currentOutstandingBalance,
                    'metrics.leases.active.total_balance': this.currentTotalBalance,
                    'metrics.leases.future.total_balance': this.totalFutureBalance,
                    'meta.updated_at': moment().unix()
    
                })
                .catch(error => {
    
                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.updated_rent_error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Update Property Total Monthly Rent in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Edit Rent',
                        uid: 'de3JZFH0g4VIgSJUPkg8',
                        error: error
                    });
    
                });

            } catch (e) {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.updated_rent_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Query Firestore When Updating a Property when Editing a Rent Term.',
                    errorType: 'Application',
                    section: 'Edit Rent',
                    uid: 'pdp6bmciygMExFaS8dWv',
                    error: e
                });

            }

		},

        updatePropertyFutureMetricsForUpdatedRent: function() {

            try {

                /*
                **  Loop through and total up the future balance for the property
                */

                if (this.future_rent_terms.length > 0) {

                    this.future_rent_terms.forEach(rent => {

                        this.totalFutureBalance = this.totalFutureBalance + rent.metrics.total_balance;

                    });

                } else {

                    /*
                    **  Update the vars
                    */

                    this.totalFutureBalance = 0;

                }

                /*
                **  Update the document
                **  @service: @Firebase/Firestore
                */

                propertiesModel.doc(this.property.id).update({

                    'metrics.units.total_monthly_rent': this.totalMonthlyRent,
                    'metrics.leases.active.outstanding_balance': this.currentOutstandingBalance,
                    'metrics.leases.active.total_balance': this.currentTotalBalance,
                    'meta.updated_at': moment().unix()
    
                })
                .catch(error => {
    
                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.updated_rent_error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Update Property Total Monthly Rent in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Edit Rent',
                        uid: 'de3JZFH0g4VIgSJUPkg8',
                        error: error
                    });
    
                });

            } catch (e) {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.updated_rent_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Query Firestore When Updating a Property when Editing a Rent Term.',
                    errorType: 'Application',
                    section: 'Edit Rent',
                    uid: 'pdp6bmciygMExFaS8dWv',
                    error: e
                });

            }

		},

    }

}